module.exports = __webpack_public_path__ + "img/tree_cache_loir402.d8a3d2d0.png";